<template>
  <div>
		<triangle-image
			title="I nostri servizi per le aziende"
      subtitle="Tante soluzioni per il tuo business"
      bodyStyle="top: 40%"
		/>
    <div class="container px-5">
      <section class="content">
        <h2 class="text-center mb-3">Regala Quomi</h2>
        <p class="pb-5 center">Scopri le nostre <b>soluzioni</b> dedicate al mondo <b>business</b>.<br/> <b>Cassette di frutta</b> consegnate <b>in ufficio</b> per il benessere dei dipendenti,<br/> <b>regali per eventi</b> aziendali fisici e digitali e <b>premi per le tue promozioni</b> in-store e online!</p>
        <div class="categories flex justify-content-around">
          <div v-for="(option, index) in options" :key="index" @click="toOption(option.id)" class="category flex flex-column flex-vcenter">
            <img :src="option.img" alt="img" loading="lazy"/>
            <h3>{{option.title}}</h3>
          </div>
        </div>
      </section>
      
      <section class="content" id="natale">
        <p class="uppercase center"><span style="font-style: italic; font-weight: bold">Soluzione 1</span> | box di natale</p>
        <div class="my-5 col-11 col-sm-4 mb-5" style="margin: 0 auto">
          <img src="https://api.quomi.it/oldimg/Quomi-box-di-natale.webp" alt="img" loading="lazy">
        </div>
        <h2 class="center">Regala le Box di Natale Quomi</h2>
        <p class="px-5 center">Quomi è la soluzione ideale per fare un regalo di Natale unico e di alta qualità con tante opzioni di personalizzazione.</p>
      </section>

      <section class="content">
        <h2 class ="pb-10 center">I vantaggi di scegliere le nostre box di Natale</h2>
          <div class="benefits">
            <div class="benefit-block">
              <span class="benefit-image image1"></span>
              <strong>Personalizzazione</strong>
              <p class="px-5 pt-5">Rendi unico il tuo regalo di Natale con un <b>packaging brandizzato</b> e su misura per le tue esigenze</p>
            </div>
            <div class="benefit-block">
              <span class="benefit-image image2"></span>
              <strong>Inserimento di flyer o gadget</strong>
              <p class="px-5 pt-5">In alternativa o in aggiunta alla personalizzazione del pack è possibile anche <b>inserire dei materiali di comunicazione</b> all’interno della box</p>
            </div> 
            <div class="benefit-block">
              <span class="benefit-image image3"></span>
              <strong>Consegna a casa</strong>
              <p class="px-5 pt-5">Consegniamo i tuoi premi direttamente a casa dei tuoi clienti o presso un punto di distribuzione concordato. Lavoriamo <b>su tutto il territorio nazionale</b></p>
            </div> 
          </div>  
      </section>

      <CTA
        class="mb-5"
        :disabled="updating"
        @click="goDown()"
        :content="`Richiedi un preventivo gratuito`"
        style="margin: 0 auto"
      />

      <hr style="width: 50%">

      <section class="content" id="gift-card">
        <p class="uppercase center"><span style="font-style: italic; font-weight: bold">Soluzione 2</span> | gift card</p>
        <div class="my-5 col-11 col-sm-4 mb-5" style="margin: 0 auto">
          <img src="https://api.quomi.it/oldimg/gift_card_quomi.webp" alt="img" loading="lazy">
        </div>
        <h2 class="center">Le Gift Card Quomi sono il regalo perfetto per stupire tutti in cucina!</h2>
        <p class="px-5 center">Le Gift Card Quomi sono perfette per regalare una nuova esperienza in cucina. In più sono facili da usare e sono valide sull'intera offerta del sito Quomi.</p> 
        <h3 class="text-center my-10">Scegli quale tipologia regalare</h3>
        <div class="flex flex-wrap flex-vcenter">
          <div class="shadow-box card-box m-auto mb-5" v-for="(card, index) in giftCards">
            <img :src="card.img" alt="img" loading="lazy">
            <h4 class="small text-bold">{{card.title}}</h4>
          </div>
        </div>
      </section>

      <CTA
        class="mb-10"
        :disabled="updating"
        @click="goDown()"
        :content="`Richiedi un preventivo gratuito`"
        style="margin: 0 auto"
      />

      <hr style="width: 50%">

      <section class="content" id="ufficio">
        <!-- <h2>Non riesci ad organizzare la tua cena aziendale di Natale? Ci pensa Quomi!</h2>
        <div class="blocks-section">
          <div class="block">
            <img src="../../assets/img/badges/gift/gift.png" alt="">
            <strong>Regalo Originale</strong>
            <p>Quomi è il servizio di spesa online che consegna a domicilio i comodi kit ricetta, le cassette di frutta e verdura di stagione e tanti altri kit e prodotti sempre di qualità certificata. 
              La sostenibilità è al centro del servizio di spesa offerto da Quomi.</p>
          </div>
          <div class="block">
            <img src="../../assets/img/badges/recipes/harvest.png" alt="">
            <strong>Prodotti di alta qualità</strong>
            <p>Per le nostre ricette e la nostra bottega selezioniamo i migliori ingredienti con l’obiettivo di garantire la massima qualità e di valorizzare i nostri produttori scelti secondo criteri di genuinità, 
              artigianalità e sostenibilità.</p>
          </div>
          <div class="block">
            <img src="../../assets/img/badges/box/delivery-express.png" alt="">
            <strong>Consegna in tutta Italia</strong>
            <p>Consegniamo in tutta Italia offrendo la massima copertura per ogni esigenza. La nostra box è pensata per garantire la qualità e freschezza di tutti gli ingredienti. 
              In più spediamo anche le schede delle ricette per seguire le istruzioni passo passo.</p>
          </div>
        </div> -->
          <p class="uppercase center"><span style="font-style: italic; font-weight: bold">Soluzione 3</span>  | frutta per il tuo ufficio</p>
          <ContinueToShop b2b/>
      </section>

      <CTA
          class="mb-10"
          :disabled="updating"
          @click="goDown()"
          :content="`Richiedi un preventivo gratuito`"
          style="margin: 0 auto"
			/>

      <hr style="width: 50%">

        <section class="content" id="eventi">
        <p class="uppercase center"><span style="font-style: italic; font-weight: bold">Soluzione 4</span> | eventi e promozioni</p>
        <div class="my-5 col-11 col-sm-4 mb-5" style="margin: 0 auto">
          <img src="https://api.quomi.it/oldimg/eventi.webp" alt="img" loading="lazy">
        </div>
        <h2 class="center">Regala l'esperienza Quomi</h2>
        <p class="px-5 center">Quomi è la soluzione ideale per fare un regalo ai dipendenti, creare eventi speciali e premiare i propri clienti</p> 
        <div class="occasions mt-10">
          <div class="occasion-block">
            <img src="https://api.quomi.it/oldimg/EventiAziendali.webp" alt="img" loading="lazy">
            <strong class="py-3">Eventi</strong>
            <p>Coinvolgi i tuoi invitati con un omaggio, organizza un originale aperitivo o una cena gourmet tutta da cucinare</p>
          </div>
          <div class="occasion-block">
            <img src="https://api.quomi.it/oldimg/Ricorrenze.webp" alt="img" loading="lazy">
            <strong class="py-3">Regali</strong>
            <p>Festeggia un evento o una ricorrenza speciale con una box unica nel suo genere</p>
          </div> 
          <div class="occasion-block">
            <img src="https://api.quomi.it/oldimg/Promo.webp" alt="img" loading="lazy">
            <strong class="py-3">Promozioni</strong>
            <p>La soluzione perfetta per premi legati ad eventi, concorsi e promozioni online ed in store</p>
          </div> 
        </div>  
      </section>
      
      <CTA
        class="mb-10"
        :disabled="updating"
        @click="goDown()"
        :content="`Richiedi un preventivo gratuito`"
        style="margin: 0 auto"
      />

        <section class="content">
          <collaboration id="collaboration"/>
        </section>

        <section class="content d-flex flex-column align-items-center">
          <h2 class="p-0 center">Contattaci per un preventivo gratuito</h2>
          <p class="text-center mt-0 mb-3">Lascia i tuoi recapiti e ti contatteremo entro 2 giorni lavorativi per inviarti un'offerta personalizzata e senza impegno.</p>
          <div class="request-info" id="request-info">
            <form
              role="form"
              method="POST"
              name="newsletter"
              action=""
              class="form"
              :class="{'flex': $mq.isDesktop() }"
              @submit.prevent="startSpinner($_newsletter_newsletterList({ email: email, name: name, business_name: business_name, list: 'business' }))"
            >
              <input 
              type="text"
              class="form-control"
              v-model="name"
              required 
              placeholder="Il tuo nome"
              />
              <input 
              type="text"
              class="form-control"
              v-model="business_name"
              required 
              placeholder="La tua azienda"
              />
              <input
                type="email"
                class="form-control"
                v-model="email"
                required
                placeholder="La tua mail"
                autocomplete="email"
              >
              <CTA
                :content="`Invia`"
                :size="`small`"
                type="submit"
                :loading="loadSpinner"
                :disabled="newsletterLoading"
                :class="{'cta': !$mq.isDesktop() }"
              />
            </form>
          </div>
          <strong class="pt-3" v-if="checkMailSent === true">La tua richiesta è stata inviata!</strong>
          <div class="small-text">
            Inviando la richiesta accetti le <router-link :to="{name: 'privacy-policy'}" :title='$t("components.checkbox.general_conditions")' target='_blank'>condizioni relative alla privacy</router-link>.
          </div>
        </section>
        <section class="paragraph d-flex flex-column align-items-center" v-if="menu && menu.recipes.length > 0">
          <!-- <h2>Prova il nostro servizio</h2>
            <SliderQ
              :minSizeOfSlide="170"
              :numberOfSlides='4'
              isCentered
            >
              <slide  v-for="(recipe, index) in menu.recipes" :key="index">
                <recipe-box
                    :item="recipe"
                    :isHover="false"
                    :isLink="false"
                    isBoxWithLink
                />
              </slide>
            </SliderQ>
            <router-link :to="{name: 'flow-subscribed'}">
							<CTA
								v-if="$route.name !== 'investors'"
								class="button mt-5"
								:content="`Fai la tua spesa`"
								isArrow
								
							/>
						</router-link> -->
            <div class="flex flex-column align-items-center mt-5 mb-10 tag-partner">
              <h2 class="center">Siamo partner ufficiale di Edenred</h2>
              <div class="col col-sm-8">
                <a href="https://ticketrestaurant.edenred.it/scopri" target="_blank" title="Instagram Quomi">
                  <img src="https://api.quomi.it/oldimg/Banners_Kit_banner-3-B.webp" alt="edenred">
                </a>
              </div>
            </div>
        </section>
    </div>
	</div>
</template>

<script type="text/javascript">
	import TriangleImage from '../TriangleImage'
  import Collaboration from '../Parts/Collaboration'
  import { newsletter } from '../../mixins/newsletter'
  import CTA from '../Elements/CTA'
  import RecipeBox from '../RecipeBox'
  import { Menu } from '../../core/Menu'
  import { WeekPlanApi } from '../../api/WeekPlanApi'
  import ContinueToShop from '../Parts/ContinueToShop'
  import { scrollToElementId } from '../../assets/js/main'

	export default {
    components: {
      TriangleImage,
      Collaboration,
      CTA,
      RecipeBox,
      ContinueToShop
    },
    data () {
      return {
        email: null,
        name: null,
        business_name: null,
        menu: null,
        recipes: null,
        loadSpinner: false,
        checkMailSent: false,
        options: [
          {
            img: "https://api.quomi.it/oldimg/natale-200.webp",
            title: "Box Natale",
            id: "natale"
          },
          {
            img: "https://api.quomi.it/oldimg/gift-card-200ok.webp",
            title: "Gift Card",
            id: "gift-card"
          },
          {
            img: "https://api.quomi.it/oldimg/frutta-200.webp",
            title: "Frutta in ufficio",
            id: "ufficio"
          },
          {
            img: "https://api.quomi.it/oldimg/eventi-200.webp",
            title: "Eventi",
            id: "eventi"
          },
        ],
        giftCards: [
          {
            img: "https://api.quomi.it/oldimg/Polpette-di-pollo-con-friggitelli-thumb-small.jpg",
            title: "Box Ricette",
          },
          {
            img: "https://api.quomi.it/oldimg/Quomi-box-di-natale.webp",
            title: "Box di Natale",
          },
          {
            img: "https://api.quomi.it/oldimg/ape2.webp",
            title: "Kit Aperitivo",
          },
          {
            img: "https://api.quomi.it/oldimg/dispensa.webp",
            title: "Card a valore",
          },
          {
            img: "https://api.quomi.it/oldimg/cass4.webp",
            title: "Cassette di frutta e verdura",
          },
        ]
      }
    },

    mixins: [newsletter],

    methods: {
      load () {
        var wm = new WeekPlanApi()

        return wm.current({}).then(response => {
          this.recipes = new Menu(response.body.data.resource).recipes
          this.menu = new Menu(response.body.data.resource)
        }).catch(response => {
        })
      },

      openVideo () {
        this.showVideo = true
      },

      startSpinner(prop) {
        this.loadSpinner = true
        setTimeout(() => {
          this.loadSpinner = false
          this.checkMailSent = true
          prop
          setTimeout(() => {
            this.checkMailSent = false
          }, 3000)
        }, 2000)
      },

      toOption(id) {
        scrollToElementId(id, 300, 100)
      },

      goDown() {
            scrollToElementId("request-info",  300, 100)
        },
    },
    mounted () {
      this.load()
    }
	}
</script>

<style scoped>
  .triangle-image {
    background: url("https://api.quomi.it/oldimg/frutta-per-uffici-e-regali-aziendali-quomi.webp");
    /*background: url("https://api.quomi.it/oldimg/natale-quomi-header-aziende.webp"); */ 
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50% 50%;
  }

  .blocks-section {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .block {
    width: 33%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 15px;
    border: 1px solid #575a5c;
    border-radius: 6px;
    text-align: center;
  }

  .block img,
  .occasion-block img {
    width: 50%;
    margin-bottom: 5px;
  }

  .block p {
    margin-top: 10px;
    margin-bottom: 0;
  }

  .benefits,
  .occasions {
    display: flex;
    justify-content: space-between;
  }

  .benefit-block,
  .occasion-block {
    width: 33.33%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }


  .benefit-image {
    width: 150px;
    height: 100px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    margin-bottom: 10px;
  }

  .image1 {
    background-image: url('https://api.quomi.it/oldimg/Personalizzazione.webp');
  }
  .image2 {
    background-image: url('https://api.quomi.it/oldimg/Flyer_Gadget-%281%29.webp');
  }
  .image3 {
    background-image: url('https://api.quomi.it/oldimg/Consegna_Casa-%281%29.webp');
  }

  .request-info {
    width: 30%;
  }

  .request-info form {
    display: flex;
    flex-direction: column;
  }

  .request-info button {
    width: 33%;
    align-self: center;
  }

  .small-text {
    font-size: 13px;
    padding-top: 10px;
  }

  .small-text a {
    text-decoration: underline;
  }

  .categories {
    flex-wrap: wrap;
  }
  .category:hover {
    cursor: pointer;
  }

  .category img {
    width: 200px;
    height: 200px;
    border-radius: 50%;
    padding-bottom: 10px;
  }

  .card-box {
      width: 200px;
      max-height: fit-content;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 5px;
      text-align: center;
  }

  .card-box img{
      border-radius: 5px;
      padding-bottom: 10px;
  }

  @media only screen and (max-width: 768px) {
    .benefits,
    .occasions {
      flex-direction: column;
      align-items: center;
    }

    .benefit-block,
    .occasion-block {
      width: 100%;
    }

    .benefit-block p,
    .occasion-block p {
      width: 100%;
      margin-top: 10px;
      margin-bottom: 20px;
    }

    .blocks-section {
      flex-direction: column;
      align-items: center;
    }

    .block {
      width: 100%;
      margin-bottom: 25px;
    }

    .request-info {
      width: 100%;
    }

    .paragraph:first-child {
      padding: 0;
    }

    .category,
    .card-box
    {
      flex-basis: calc(100%/2 - 10px);
      margin-bottom: 10px;
    }

    .category img {
      width: 120px;
      height: 120px;
    }
  }

  @media only screen and (max-width: 380px) {
    .category h3 {
      font-size: 13px;
    }

    .triangle-image {
      background-image: url("https://api.quomi.it/oldimg/cover-box-mobile-gift-natale-quomi.webp");
      background-position: 50% 50%;
    }
  }

  @media only screen and (min-width: 769px) and (max-width: 1024px) {
    .paragraph:nth-child(5) p {
      width: 80%;
    }

    .request-info {
      width: 60%;
    }
  }
</style>